module.exports = __webpack_public_path__ + "img/Events_Placeholder.2b0e68c1.png";